import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Footer from '../../components/Footer';
import 'wicg-inert';
import ScrollToTop from "../../libs/scrollToTop";
import { useKonami } from 'react-konami-code';
import Nav from '../../components/Nav.js';
import SecondaryNav from '../../components/SecondaryNav';

import ModalOverlay from "../../components/ModalOverlay";

import heroMobileImage from '../../images/articles/PO0131005_WF_BRAND_2HFY24_ISF_SepUpdate13_LP_767x577.jpg';
import heroDesktopImage from '../../images/articles/PO0131005_WF_BRAND_2HFY24_ISF_SepUpdate13_LP_1164x584.jpg';

import { fireTag } from '../../libs/analytics.js';

const Transformative = ({
    handleEvent,
    closeExitOverlay,
    addExitClickListeners,
    modalOverlay,
}) => {

    const [enableScrollGA, setEnableScrollGA] = useState(false);
    const [shouldBeInert, setShouldBeInert] = useState(false);
    const [gridVisible, setGridVisible] = useState(false);
    const heroOGImage = 'PO0131005_WF_BRAND_2HFY24_ISF_SepUpdate13_LP_ogimage.jpg';

    const toggleInert = () => {
        setShouldBeInert(!shouldBeInert)
    }

    const linkDisclosures = () => {
		const bodyDisclosures = document.querySelectorAll('.body-disclosures');
		const footerDisclosures = document.querySelectorAll('.footer-disclosures');
		bodyDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = footerDisclosures[disclosureNumber - 1];
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});

		footerDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = bodyDisclosures[disclosureNumber - 1];
				fireTag('A2',disclosureNumber);
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});
	}

	useEffect(() => {
		linkDisclosures();
		addExitClickListeners();
	}, []); // empty array says only use this effect once

    let mastheadImage = window.innerWidth < 768 ? heroMobileImage : heroDesktopImage;

    return (
		<>
			<Helmet>
				<title>Three transformative renewable energy transactions</title>
				<meta
					name="description"
					content="Wells Fargo supports clients by providing insights, capital, and financial products to achieve their transition goals."
				/>
				<meta property="og:title" content="Three transformative renewable energy transactions"/>
				<meta
					property="og:description"
					content="Wells Fargo supports clients by providing insights, capital, and financial products to achieve their transition goals."
				/>
				<meta property="og:image" content={`https://welcome.wf.com/impact/images/articles/${heroOGImage}`}/>

				<meta property="twitter:title" content="Three transformative renewable energy transactions"/>
				<meta
					property="twitter:description"
					content="Wells Fargo supports clients by providing insights, capital, and financial products to achieve their transition goals."
				/>
				i
			</Helmet>
			{/*TODO: isMobile should be passed in from route, not calc'd here */}

			<Nav handleEvent={handleEvent} isNotHomePage={false} activePage="articles" isMobile={window.innerWidth < 768} showExternalNav toggleInert={toggleInert} shouldBeInert={shouldBeInert}/>

			{!window.innerWidth < 768 && (
				<SecondaryNav page="Articles" shouldBeInert={shouldBeInert} activePage="articles"/>
			)}


			<main className="flex-container">

				<div className="flex-row">
					<div className="flex-col-sm-12 flex-col-md-8 text-center headline">
						<h1 id="articles-main-h1" style={{marginBottom: 10}}>
                            Three transformative renewable energy transactions
						</h1>
						<h2 className="summary">
                        Wells Fargo supports clients by providing insights, capital, and financial products to achieve their transition goals.
                        </h2>
					</div>

				</div>

				<div className="flex-row full-width-md">
					<div className="flex-col-lg-10 flex-col-md-10 text-center hero-container">
						<img src={mastheadImage} alt="Two workers by wind turbines in rural landscape."/>
					</div>
				</div>

				<div className="flex-row">
					<div className="flex-col-md-8 flex-col-sm-12 text-center article-intro info-graphic">
						<div className="article-info">
							<div>
								<p>September 19, 2024</p>
							</div>
							<div>
								<p>3-minute read</p>
							</div>
						</div>
						<p>
                        Wells Fargo’s 2023 Climate Report highlights notable transactions that support clients’ climate-related activities and goals. Three of the featured clean energy projects demonstrate innovation and impact in various sectors.
						</p>
                        <h2 className="subhead" style={{marginTop: '1rem'}}>
                            1. Propelling a history-making wind project
						</h2>
						<p>
                        A <a onClick={()=> fireTag('A1','wind and transmission project')} target="_blank" href="https://patternenergy.com/pattern-energy-closes-11-billion-financing-of-largest-clean-energy-infrastructure-project-in-u-s-history/" rel="noreferrer">wind and transmission project</a> in New Mexico aims to be the largest clean energy infrastructure initiative in U.S. history. In December 2023, Wells Fargo arranged $8.8 billion in financing for Pattern Energy’s SunZia project — a 550-mile transmission line and a 3.5 GW wind project designed to enhance power distribution across several western states.
						</p>
                        <p>
                        Daniel Elkort, executive vice president at Pattern Energy, said, “The size and scale of both the SunZia project and this multifaceted financing show that the renewable energy space can secure attractive capital at levels previously only seen in traditional generation.” 
						</p>
                        <p>
                        The project is <a onClick={()=> fireTag('A1','expected to provide')} target="_blank" href="https://patternenergy.com/projects/sunzia-wind/" rel="noreferrer">expected to provide</a> enough safe, affordable, renewable electricity to power the needs of more than three million Americans. It is also anticipated to create more than 100 jobs to operate and maintain the facility. 
                        </p>
                        <h2 className="subhead" style={{marginTop: '1rem'}}>
                        2. Developing renewable diesel fuel
                        </h2>
                        <p>Wells Fargo led a $425 million asset-based lending deal to convert an oil refinery into a renewable diesel biorefinery in Louisiana. St. Bernard Renewables, a joint venture with Eni Sustainable Mobility and PBF Energy, produces <a onClick={()=> fireTag('A1','18,000 barrels')} target="_blank" href="https://biomassmagazine.com/articles/pbf-energy-sbr-boosts-renewable-diesel-production-secures-provisions-carb-pathway" rel="noreferrer">18,000 barrels</a> of fuel per day with capacity to produce more than <a onClick={()=> fireTag('A1','300 million gallons')} target="_blank" href="https://www.willkie.com/news/2023/07/willkie-advises-pbf-energy-on-completion-of-renewable" rel="noreferrer">300 million gallons</a> per year. </p>
                        <p>
                        “What’s really attractive about renewable diesel is that it can go into any truck that burns diesel,” said Wesley Shaw, senior vice president of originations at Wells Fargo Capital Finance. “Renewable diesel works with everyday trucks, farming equipment, and 18-wheelers.” 
                        </p>
                        <p>
                        <a onClick={()=> fireTag('A1','renewable diesel')} target="_blank" href="https://afdc.energy.gov/fuels/renewable-diesel" rel="noreferrer">Renewable diesel</a> can result in fewer carbon dioxide and nitrogen oxide emissions when compared with petroleum diesel. It also offers more flexibility since it can be made from multiple feedstocks.
                        </p>
                        <h2 className="subhead" style={{marginTop: '1rem'}}>
                        3. Supporting client’s renewable energy goals
						</h2>
						<p>
                        Wells Fargo underwrote Verizon's fifth <a onClick={()=> fireTag('A1','green bond')} target="_blank" href="https://www.verizon.com/about/news/verizon-issues-its-fifth-1-billion-green-bond" rel="noreferrer">green bond</a> aimed at funding renewable energy investments to lower carbon emissions. The solar and wind energy <a onClick={()=> fireTag('A1','projects')} target="_blank" href="https://www.utilitydive.com/news/verizon-allocates-1B-green-bond-renewable-energy-projects/708207/" rel="noreferrer">projects</a> are being developed in Illinois, Maine, North Dakota, Ohio, and West Virginia. The allocations build on the telecommunications company’s goal to achieve net-zero emissions across its operations by 2035. 
						</p>
                        <p>Tony Skiadas, Verizon’s executive vice president and chief financial officer said, “I believe our actions speak louder than our words, and I am proud of the steps Verizon has taken towards our ambitious environmental and social impact goals.”</p>
                        <p>These three projects illustrate how strategic sustainable financing can accelerate the transition to a low-carbon energy future.</p>
					</div>
				</div>
			</main>


			<Footer id="footer" footerStyles="global" shouldBeInert={shouldBeInert} activePage="sustainability" enableScrollGA={enableScrollGA}/>

			{modalOverlay && modalOverlay.open && (
				<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay}/>
			)}
		</>
    );

};

export default withRouter(Transformative);



